import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/btn_strava_connectwith_orange.png'


const _hoisted_1 = { class: "container pt-5 p-2 text-start" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "pb-3" }, "Påmelding", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " For å kunne delta i Klatrekongen må du være Strava Premium bruker. Dette er i henhold til Strava sine regler og retningslinjer. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Hvilke data samles inn og lagres?", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Fullt navn & kjønn"),
  /*#__PURE__*/_createElementVNode("li", null, "Personlig strava-id"),
  /*#__PURE__*/_createElementVNode("li", null, " Raskeste tid på relevante segmenter og tilhørende aktivitets-id for å linke til aktiviteten din ")
], -1)
const _hoisted_6 = { class: "my-4" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Meld deg på her: ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", { class: "mt-5" }, "Avmelding", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, " Du kan når som helst melde deg av Klatrekongen. Vi sletter da all data vi har lagret om deg. Følg disse stegene for å melde deg av: ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" Logg inn på "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.strava.com/login",
      target: "_blank"
    }, " Strava sine nettsider")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "Hold musepekeren over profil-ikonet ditt"),
  /*#__PURE__*/_createElementVNode("li", null, "Trykk på \"Settings\""),
  /*#__PURE__*/_createElementVNode("li", null, "I menyen til venstre trykker du på \"My Apps\""),
  /*#__PURE__*/_createElementVNode("li", null, "Finn Klatrekongen og trykk \"Revoke Access\"")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("p", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("img", {
        class: "btn ms-2 p-0 border-0",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.connectWithStrava && _ctx.connectWithStrava(...args))),
        src: _imports_0,
        alt: ""
      })
    ]),
    _hoisted_8,
    _hoisted_9,
    _hoisted_10
  ]))
}